/**
 * Gatsby Browser APIs
 * Wraps the root element with MUI emotion cache for client-side rendering.
 */
import React from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

const cache = createCache({ key: 'css', prepend: true });

export const wrapRootElement = ({ element }) => (
  <CacheProvider value={cache}>{element}</CacheProvider>
);

export const onInitialClientRender = () => {
  const hideLoader = () => {
    const loader = document.getElementById('___page-loader');
    if (!loader) return;
    loader.style.opacity = '0';
    setTimeout(() => loader.remove(), 500);
  };

  if (document.readyState === 'complete') {
    hideLoader();
  } else {
    window.addEventListener('load', hideLoader, { once: true });
  }
};
